// extracted by mini-css-extract-plugin
export default {"outer":"authorization_outer__wAx+P"};